const URLAPI = 'https://apiphp.n4col.com/'

export default URLAPI;

